$(document).ready(function() {


  // jquery for Parallax banner
  const $heroParent = $('.Hero_parent');
  setTimeout(() => {
    $heroParent.removeClass('Hero_parent___start');
  }, 100);

  const $hero = $('#parallax-parent');
  const $children = $hero.children().toArray();

  const mouse = {
    x: 0,
    y: 0,
  };

  const easedMouse = {
    x: 0,
    y: 0,
  };

  const handleMouseMove = (e) => {
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    if (isTouch) {
      return;
    }

    const x = e.touches?.length ? e.touches[0]?.clientX : e.clientX;
    const y = e.touches?.length ? e.touches[0]?.clientY : e.clientY;

    mouse.x = ((x / window.innerWidth) * 2 - 1) * 2;
    mouse.y = ((y / window.innerHeight) * 2 - 1) * 2;
  };

  $(window).on('pointermove', handleMouseMove);

  const animate = () => {
    easedMouse.x += (mouse.x - easedMouse.x) / 20;
    easedMouse.y += (mouse.y - easedMouse.y) / 20;

    const strength = $children.length / 5;

    $children.forEach((child, i) => {
      $(child).css('transform', `translate3d(${easedMouse.x * (i + 1) * strength}vh, ${easedMouse.y * (i + 1) * strength}vh, 0)`);
    });

    frame = window.requestAnimationFrame(animate);
  };

  let frame = window.requestAnimationFrame(animate);

  $(window).on('unload', () => {
    window.cancelAnimationFrame(frame);
    $(window).off('pointermove', handleMouseMove);
  });


  // Page Animation Calling function.
  // scrollAnimation();

  // slick slider for before after section
  if($('.slick-slider').length){
    $('.slick-slider').not('.slick-initialized').slick({
      arrows: false,
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: false,
      swipe: false,
    });
  }

});

$(window).on('load', function() {
  setTimeout(function() {
    $('.newsletter__wrapper input').on('focusin', function() {
      $(this).parent().find('label').addClass('active');
    });
    $('.newsletter__wrapper input').on('focusout', function() {
      if (!this.value) {
        $(this).parent().find('label').removeClass('active');
      }
    });
  }, 1000);
});

// Page Animation
function scrollAnimation(){
  new SmoothScroll(document,120,12)
}

function SmoothScroll(target, speed, smooth) {
  if (target === document)
    target = (document.scrollingElement 
    || document.documentElement 
    || document.body.parentNode 
    || document.body) // cross browser support for document scrolling
    
  var moving = false
  var pos = target.scrollTop
  var frame = target === document.body 
  && document.documentElement 
  ? document.documentElement 
  : target // safari is the new IE
  
  target.addEventListener('mousewheel', scrolled, { passive: false })
  target.addEventListener('DOMMouseScroll', scrolled, { passive: false })
  
  function scrolled(e) {
    e.preventDefault(); // disable default scrolling
    
    var delta = normalizeWheelDelta(e)
    
    pos += -delta * speed
    pos = Math.max(0, Math.min(pos, target.scrollHeight - frame.clientHeight)) // limit scrolling
    
    if (!moving) update()
  }
  
  function normalizeWheelDelta(e){
    if(e.detail){
      if(e.wheelDelta)
        return e.wheelDelta/e.detail/40 * (e.detail>0 ? 1 : -1) // Opera
      else
      return -e.detail/3 // Firefox
    }else
    return e.wheelDelta/120 // IE,Safari,Chrome
  }
  
  function update() {
    moving = true

    var delta = (pos - target.scrollTop) / smooth

    target.scrollTop += delta

    if (Math.abs(delta) > 0.5)
      requestFrame(update)
    else
    moving = false
  }
  
  var requestFrame = function() { // requestAnimationFrame cross browser
    return (
      window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.oRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function(func) {
        window.setTimeout(func, 1000 / 50);
      }
    );
  }()
}

// Hide shop button when product form submit button is clicked
$('.product-form__submit').on('click', function() {
    $('.shop_button').hide();
    $('#cart-icon-bubble').css('display','flex');
});

// Show shop button when the element with ID Remove-1 is clicked
$('#Remove-1').on('click', function() {
    $('.shop_button').removeClass('buttonHide');
});

/*
 * Focusrand van de headericonen alleen bij toetsenbordgebruik.
 *
 * Het cartsymbool opent de cartlade. Bij het sluiten zet het thema de focus met
 * .focus() terug op dat symbool, en een browser behandelt zo'n programmatische focus
 * als :focus-visible. Daardoor bleef er na een tik een vierkante rand om het symbool
 * staan, zichtbaar op iOS. De rand zelf hoort te blijven voor wie met tab navigeert,
 * dus die wordt niet weggehaald, alleen onderdrukt zolang de laatste bediening een
 * tik of een muisklik was.
 */
(function () {
  var root = document.documentElement;
  var navKeys = ['Tab', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Escape'];

  function pointer() { root.setAttribute('data-pointer-input', 'true'); }
  function keyboard(event) {
    if (navKeys.indexOf(event.key) === -1) return;
    root.removeAttribute('data-pointer-input');
  }

  window.addEventListener('pointerdown', pointer, true);
  window.addEventListener('touchstart', pointer, { capture: true, passive: true });
  window.addEventListener('mousedown', pointer, true);
  window.addEventListener('keydown', keyboard, true);
})();
